import React from 'react'
import { Button } from '@material-ui/core'
import { DownloadCSVPopup } from 'components'

type DownloadCSVButtonProps = {
  buttonText?: string
  reportFileName: string
  enabled: boolean
  gsUrl: string
  onDownload: () => void
}

export const DownloadCSVButton = (props: DownloadCSVButtonProps) => {
  const { buttonText = 'Download Data (CSV)', reportFileName, gsUrl, onDownload, enabled } = props
  const [downloadModalOpen, setDownloadModalOpen] = React.useState<boolean>(false)
  const downloadDisabled = !enabled || !!gsUrl
  // Ensures modal doesn't open on re-render
  const [downloadInitiated, setDownloadInitiated] = React.useState<boolean>(false)

  React.useEffect(() => {
    if (downloadInitiated === true && gsUrl !== '') {
      setDownloadInitiated(false)
      setDownloadModalOpen(true)
    }
  }, [downloadInitiated, gsUrl])

  return (
    <>
      <Button
        variant="text"
        disabled={downloadDisabled}
        className={`text-primary underline normal-case text-lg ${downloadDisabled ? 'opacity-50' : ''}`}
        onClick={() => {
          if (gsUrl === '') {
            setDownloadInitiated(true)
            onDownload()
          } else {
            setDownloadModalOpen(true)
          }
        }}
      >
        {buttonText}
      </Button>
      <DownloadCSVPopup
        open={downloadModalOpen}
        onClose={() => setDownloadModalOpen(false)}
        reportFileName={reportFileName}
      />
    </>
  )
}
